import { ScreenReaderNotifier } from '@/components/ScreenReaderNotifier'
import { BodyM, HeadingS } from '@/components/Typography'

import { useElementAutoFocus } from '@/hooks/useElementAutoFocus'

import { useFgtsLoanSimulator } from '../../core/context'

import * as Simulation from './styles'

interface FgtsFieldProps {
  shouldFocus: boolean
}

export const FgtsField = ({ shouldFocus }: FgtsFieldProps) => {
  const { availableAmountRef } = useFgtsLoanSimulator()
  const elementRefToBeFocused = useElementAutoFocus(shouldFocus)

  return (
    <div ref={elementRefToBeFocused}>
      <ScreenReaderNotifier
        enabled={shouldFocus}
        allowSuppressOtherElements={false}
        label="Informe o valor em reais do seu saldo de FGTS"
      />
      <HeadingS html="Qual é o valor que você possui no FGTS?" />
      <BodyM html="Informe o valor em reais que você possui no seu FGTS." />
      <Simulation.CurrencyField
        id="fgts-field"
        ref={availableAmountRef}
        aria-label="Digite o valor em reais que você possui no seu saldo do FGTS"
      />
    </div>
  )
}
